import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { CommentRestService } from "@app/services/hal/comment-rest-service";
import { CommentModel } from "@app/models/rest/comment-model";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class CommentStore extends RealTimeDataStore<CommentModel> {
  constructor() {
    const commentRestService = inject(CommentRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(commentRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Comment");
  }
}
